import type { ApiErrorTextOptions } from "@/lib/api-error";

/** `apiErrorText` options shared by the auth forms: auth codes, then the password rule. */
export const AUTH_ERROR_OPTIONS: ApiErrorTextOptions = {
  namespace: "auth.errors",
  fields: { password: "auth.passwordHintLong" },
};
